<script lang="ts">
  import Box from '../components/boxes/Box.svelte';
  import ErrorBox from '../components/boxes/ErrorBox.svelte';
  import NoticeBox from '../components/boxes/NoticeBox.svelte';
  import SuccessBox from '../components/boxes/SuccessBox.svelte';
  import WarningBox from '../components/boxes/WarningBox.svelte';
  import { LayerService } from '../services/LayerService.svelte';
  import Headline from '../components/content/Headline.svelte';
  import Content from '../components/content/Content.svelte';
  import Button from '../components/content/Button.svelte';
  import ButtonLine from '../components/content/ButtonLine.svelte';

  const Layer = new LayerService();
  const MyLayer = Layer.getContentLayer();

  // - Vorschau: zeigt an, welcher Button zuletzt ausgelöst hat
  let LastAction = $state('noch nichts');

  function reportAction(name: string): () => void {
    return () => {
      LastAction = name;
    };
  }
</script>

<main class="LayoutMain contentLayer contentLayer{MyLayer} contentLayerChildAbs">
  <Headline state="brand">DWC-Tools Layout Preview</Headline>
  <Content removeMarginTop={true}>
    <p>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
      accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
  </Content>

  <Box>
    {#snippet headline()}Text{/snippet}
    <p>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
      accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
  </Box>
  <Box state="gray">
    {#snippet headline()}Grau{/snippet}
    <p>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
      accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
  </Box>
  <ErrorBox>
    {#snippet headline()}Fehler{/snippet}
    <p>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
      accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
  </ErrorBox>
  <NoticeBox>
    {#snippet headline()}Hinweis{/snippet}
    <p>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
      accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
  </NoticeBox>
  <SuccessBox>
    {#snippet headline()}Erfolg{/snippet}
    <p>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
      accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
  </SuccessBox>
  <WarningBox>
    {#snippet headline()}Warnung{/snippet}
    <p>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
      accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
    </p>
  </WarningBox>

  <Box layerAbs={true}>
    {#snippet headline()}Buttons{/snippet}
    <Content>
      <p>Zuletzt ausgelöst: <strong>{LastAction}</strong></p>
    </Content>

    <Box lightDarker={true}>
      {#snippet headline()}Elemente{/snippet}
      <ButtonLine align="left">
        <Button onclick={reportAction('onclick')}>Mit onclick (button)</Button>
        <Button href="/#Button">Mit href (a)</Button>
        <Button href="https://www.dwc.gmbh">Externer Link</Button>
      </ButtonLine>
    </Box>

    <Box lightDarker={true}>
      {#snippet headline()}Deaktiviert{/snippet}
      <ButtonLine align="left">
        <Button>Ohne onclick und href</Button>
        <Button disabled={true} onclick={reportAction('nie')}>Von Hand abgeschaltet</Button>
      </ButtonLine>
    </Box>

    <Box lightDarker={true}>
      {#snippet headline()}Farben{/snippet}
      <ButtonLine align="left">
        <Button onclick={reportAction('brand')}>Brand (Vorgabe)</Button>
        <Button state="gray" onclick={reportAction('gray')}>Gray</Button>
        <Button state="notice" onclick={reportAction('notice')}>Notice</Button>
        <Button state="success" onclick={reportAction('success')}>Success</Button>
        <Button state="warning" onclick={reportAction('warning')}>Warning</Button>
        <Button state="error" onclick={reportAction('error')}>Error</Button>
      </ButtonLine>
    </Box>

    <Box lightDarker={true}>
      {#snippet headline()}Rückfrage und Haltezeit{/snippet}
      <ButtonLine align="left">
        <Button state="warning" question="Sind Sie sicher?" onclick={reportAction('mit Rückfrage')}>Mit Rückfrage</Button>
        <Button state="error" hold={3} onclick={reportAction('nach 3 Sekunden')}>Zeitbutton</Button>
        <Button state="error" hold={2} question="Wirklich löschen?" onclick={reportAction('gehalten und bestätigt')}>Halten und bestätigen</Button>
      </ButtonLine>
    </Box>

    <Box lightDarker={true}>
      {#snippet headline()}Ausrichtung{/snippet}
      <ButtonLine>
        <Button align="center" onclick={reportAction('zentriert')}>Zeile und Text zentriert</Button>
        <Button align="left" onclick={reportAction('linksbündig')}>Text linksbündig</Button>
      </ButtonLine>
    </Box>
  </Box>
</main>

<style lang="scss">
</style>
